module.exports = __webpack_public_path__ + "static/media/reports_open_menu_reports.8b0c1b9e.mov";